// extracted by mini-css-extract-plugin
export default {"uploadVideo":"styles_uploadVideo__GKQIX","buttonTextStyle":"styles_buttonTextStyle__k63Kz","skeleton":"styles_skeleton__9kTwk"};